var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6 3.333a.6.6 0 0 0-1.2 0V7.4H3.667a.6.6 0 1 0 0 1.2H7.4v4.067a.6.6 0 1 0 1.2 0V8.6h3.733a.6.6 0 1 0 0-1.2H8.6V3.333Z",
    fill: "#fff"
  })));
};

export default SvgPlus;